const _ = require('lodash')

exports.TYPES = {
  ARTICLE: 'article',
  /**
   * Support `category` model type as a synonym for `interest`
   * @see https://app.asana.com/0/857970715837912/928351645776875/f
   */
  CATEGORY: 'category',
  INTEREST: 'interest',
  MIX: 'mix',
  USER: 'user'
}

exports.TYPES_KEYS = _.invert(exports.TYPES)

exports.ARTICLE_SUBTYPES = {
  VIDEO: 'video',
  AUDIO: 'audio',
  IMAGE: 'image',
  TEXT: 'text',
  TEXT_WITH_IMAGE: 'text_with_image'
}

exports.ARTICLE_SUBTYPES_KEYS = _.invert(exports.ARTICLE_SUBTYPES)
